import clsx from "clsx";

export const InputText = ({ value, setValue, onBlur, disabled=false, placeholder=null,
                            theme="light", size="md", helper=null, className }) => {

  const handleOnChange = (e) => {
    setValue?.(e.target.value);
  };

  const getThemeClasses = () => {
    return theme === 'light' ?
      'text-perception-gray-700 bg-gray-100' :
      'text-perception-gray-500 bg-perception-black-500 placeholder-perception-gray-700';
  };

  const getSizeClasses = () => {
    return size === 'sm' ? 'text-sm px-2 py-1 border-1' :
      size === 'lg' ? 'text-xl px-4 py-2 border-2' :
      'px-2 py-1 border-1'; // default & md
  };

  const getHelperSizeClasses = () => {
    return size === 'sm' ? 'text-xs' :
      size === 'md' ? 'text-xs' :
      size === 'lg' ? 'text-sm' : '';
  };

  return (
    <div className="inline-block flex flex-col items-end">
      <input
        type="text"
        value={value}
        onChange={handleOnChange}
        onBlur={onBlur}
        className={clsx(getThemeClasses(), getSizeClasses(), 'rounded-md outline-none border-transparent focus:border-perception-blue', className)}
        disabled={disabled}
        placeholder={placeholder}
      />
      {
        helper && <p className={clsx(getHelperSizeClasses(), 'text-perception-gray-600 mt-1')}>{helper}</p>
      }
    </div>

  );
};